import { render, staticRenderFns } from "./WorkerCompensation.vue?vue&type=template&id=55de071e&"
import script from "./WorkerCompensation.vue?vue&type=script&lang=js&"
export * from "./WorkerCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports